export default __webpack_public_path__ + "static/media/BW.8e93a74e.svg";